<template>
  <div class="product-selector">
    <div class="data select-options" v-if="validSelection && options.once_off.data.length > 0">
      <p id="data-label">BUY A DATA BUNDLE – <span class="text-primary">You get a FREE 1GB WhatsApp Bundle with every DATA recharge</span></p>      
      <vue-toggle
        :options="options.once_off.data"
        :selected.sync="recharge.data"
        class="row no-gutters"
      >
        <template slot-scope="{item}">
          <div v-bind:class="item.display_details != null && item.display_details.meta_keyword != '' ? item.display_details.meta_keyword : 'col'">
            <button
              type="button"
              class="btn btn-default text-white"
              v-on:click="recharge.data = recharge.data != item ? item : null"
              v-bind:class="[
              'btn', 
              recharge.data != null && recharge.data.id === item.id ? 'btn-primary text-white': (item.is_popular === true ? 'text-primary ' : 'text-white ') + 'btn-dark']"
            >
            <span v-if="item.display_details != null">
              <span class="name">{{ item.name }} - {{ item.price | currency }}</span>
              <small>{{ item.display_details.description }}</small>              
            </span>
            <span v-else>
              <span class="name">{{ item.name }}</span>              
              <span>{{ item.price | currency }}</span>
            </span>              
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div class="mins select-options" v-if="validSelection && options.once_off.mins.length > 0">
      <label id="mins-label">Buy a Minute Bundle</label>
      <vue-toggle
        :options="options.once_off.mins"
        :selected.sync="recharge.mins"
        class="row no-gutters"
      >
        <template slot-scope="{item}">
          <div class="col">
            <button
              type="button"
              class="btn btn-default"
              v-on:click="recharge.mins = recharge.mins != item ? item : null"
              v-bind:class="['btn', recharge.mins != null && recharge.mins.id === item.id ? 'btn-primary': 'btn-dark']"
            >
              <span class="name">{{ item.name }}</span>
              <span>{{ item.price | currency }}</span>
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div class="sms select-options" v-if="validSelection && options.once_off.sms.length > 0">
      <label id="sms-label">Buy an SMS Bundle</label>
      <vue-toggle
        :options="options.once_off.sms"
        :selected.sync="recharge.sms"
        class="row no-gutters"
      >
        <template slot-scope="{item}">
          <div class="col">
            <button
              type="button"
              class="btn btn-default"
              v-on:click="recharge.sms = recharge.sms != item ? item : null"
              v-bind:class="['btn', recharge.sms != null && recharge.sms.id === item.id ? 'btn-primary': 'btn-dark']"
            >
              <span class="name">{{ item.name }}</span>
              <span>{{ item.price | currency }}</span>
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div
      class="whatsApp select-options"
      v-if="validSelection && options.once_off.whatsApp.length > 0"
    >
      <label id="whatsApp-label">Buy a WhatsApp Bundle</label>
      <vue-toggle
        :options="options.once_off.whatsApp"
        :selected.sync="recharge.whatsApp"
        class="row no-gutters"
      >
        <template slot-scope="{item}">
          <div class="col">
            <button
              type="button"
              class="btn btn-default"
              v-on:click="recharge.whatsApp = recharge.whatsApp != item ? item : null"
              v-bind:class="['btn', recharge.whatsApp != null && recharge.whatsApp.id === item.id ? 'btn-primary': 'btn-dark']"
            >
              <span class="name">{{ item.name }}</span>
              <span>{{ item.price | currency }}</span>
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div class="no-deal-selected" v-if="recharge.has_error">{{ recharge.message }}</div>

    <div class="page-controls no-gutters mt-4">
      <div class="row">
        <div
          class="col-sm-12 col-md-6 form-group contact-number"
          v-bind:class="{ 'has-errors': errors.has('mobile_number') }"
        >
          <the-mask
            mask="### ### ####"
            type="tel"
            v-validate="'required|digits:10'"
            name="mobile_number"
            class="form-control"
            data-vv-as="Mobile Number"
            v-model="mobile_number"
            placeholder="Enter Your Mobile Number eg. 061 555 9988"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('mobile_number')"
            >A valid 10 digit me&amp;you number is required (eg. 061 555 9988).</span>
          </transition>
        </div>
        <div class="col-sm-12 col-md-6">
          <button type="button" class="btn btn-primary" @click="isValidInputs">
            Pay Now
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "product-selector",
  props: ["recharge"],
  data: function() {
    return {
      mobile_number: null
    };
  },
  computed: {
    options() {
      return store.state.products.products.options;
    },
    isLoading() {
      return store.state.products.is_loading;
    },
    validSelection() {
      var self = this;
      return !self.isEmpty(self.recharge);
    },
    hasValidSelection() {
      var self = this;

      var isValid = (
        !self.isEmpty(self.recharge) &&
        (!self.isEmpty(self.recharge.mins) ||
          !self.isEmpty(self.recharge.data) ||
          !self.isEmpty(self.recharge.sms) ||
          !self.isEmpty(self.recharge.whatsApp))
      );
      return isValid;
    }
  },
  watch: {
    hasValidSelection: {
      handler(value) {
        var self = this;
        if(!value) {
          self.recharge.has_error = true;
          self.recharge.message = "You have not selected a product above."
        } else {
          self.recharge.has_error = false;
        }
      },  
      deep: true
    }
  },
  methods: {
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    isValidInputs() {
      var self = this;
      self.$log.debug("CHECK VALID INPUTS");
      self.$validator.validateAll().then(success => {
        
        if(!self.hasValidSelection) {                    
          self.recharge.has_error = true;
          self.recharge.message = "You have not selected a product above."
        }

        self.$log.debug("VALID INPUTS | " + success);
        if (success && self.hasValidSelection) {
          self.recharge.msisdn = self.mobile_number;
          self.$emit("recharge:paynow", true);          
        } 

        return success;
      });
    }
  }
};
</script>